import { Provider } from "@angular/core";
import { ImagePreviewService } from "./services/image-preview.service";
import { PdfPreviewService } from "./services/pdf-preview.service";
import { FilePreviewService } from "./services/file-preview.service";

export function provideFilePreview(): Provider[] {
  return [ImagePreviewService, PdfPreviewService, FilePreviewService];
}
